import { Box, Center, Group, Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { EmptyStateTableProps } from "../interfaces/encounter-table";

export function EmptyStateTable({ icon, message, columns }: EmptyStateTableProps) {
  return (
    <Box
      style={{
        overflow: "hidden",
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-cream-4)",
      }}
    >
      <Table withRowBorders verticalSpacing="md" borderColor="cream.4" horizontalSpacing="md">
        <Table.Thead bg="cream.3">
          <Table.Tr>
            {columns.map((column) => (
              <Table.Th key={column}>
                <TextWrapper c="dark.9" variant="bold">
                  {column}
                </TextWrapper>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td colSpan={columns.length}>
              <Center
                py="xs"
                w="100%"
                bg="gray.1"
                style={{ borderRadius: "var(--mantine-radius-sm)" }}
              >
                <Group gap="xs" align="center" justify="center">
                  {icon}
                  <TextWrapper c="gray.7">{message}</TextWrapper>
                </Group>
              </Center>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Box>
  );
}
